import type { ICopilotAction } from "../interfaces/copilot-interfaces";

/*
 * The three use cases the welcome screen puts forward, taken from the design. The guillemets are
 * presentation — these are examples of what can be said — so only the question itself is sent.
 */
export const CopilotWelcomeSuggestions: ICopilotAction[] = [
  {
    actionId: "remaining-seats",
    label: "« Reste-t-il des places dans les prochaines sessions Excel ? »",
    prompt: "Reste-t-il des places dans les prochaines sessions Excel ?",
  },
  {
    actionId: "attendee-trainings",
    label: "« À quelles formations cette personne est-elle inscrite ? »",
    prompt: "À quelles formations cette personne est-elle inscrite ?",
  },
  {
    actionId: "what-can-i-ask",
    label: "« Quelles questions puis-je poser à Simbel AI ? »",
    prompt: "Quelles questions puis-je poser à Simbel AI ?",
  },
];
